import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { usePagedSearch, Pager, SearchBox } from "./Pager";

function CollapsibleHeader({ id, title, count, open, toggle, right }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <button onClick={toggle} className="flex items-center gap-2 text-left" aria-expanded={open} data-testid={`cl-${id}-toggle`}>
        <ChevronDown size={18} className={`text-gold transition-transform ${open ? "" : "-rotate-90"}`} />
        <h3 className="font-serif-display text-xl font-bold text-crimson">{title} <span className="ml-1 font-mono-accent text-sm text-muted-foreground">({count})</span></h3>
      </button>
      {right}
    </div>
  );
}

// Collapsible section with optional search + 10/25/50/100 pager for long lists. Preferences only in localStorage.
export function CollapsibleList({ id, title, count, rows: rowsProp, render, empty, searchable, matcher, placeholder, defaultOpen = true, right }) {
  const rows = rowsProp || [];
  const [open, setOpen] = useState(() => { const v = localStorage.getItem(`cl-${id}`); return v === null ? defaultOpen : v === "1"; });
  const toggle = () => setOpen((o) => { localStorage.setItem(`cl-${id}`, o ? "0" : "1"); return !o; });
  const pg = usePagedSearch(rows, `cl-${id}-size`, matcher || (() => true), 10);
  const total = pg.filtered.length;
  return (
    <section data-testid={`cl-${id}`}>
      <CollapsibleHeader id={id} title={title} count={count ?? rows.length} open={open} toggle={toggle} right={right} />
      {open && (
        <div className="mt-3" data-testid={`cl-${id}-body`}>
          {searchable && <SearchBox value={pg.q} onChange={pg.setQuery} placeholder={placeholder} testId={`cl-${id}-search`} className="mb-2 w-72" />}
          {total === 0 ? <p className="text-sm text-muted-foreground">{empty}</p> : <div className="space-y-2">{pg.shown.map(render)}</div>}
          {rows.length > 10 && <Pager p={pg} total={total} noun="items" testId={`cl-${id}-pager`} />}
        </div>
      )}
    </section>
  );
}
